/**
 * <parts-diagram> — Bilga Kids Ersatzteil-Zeichnung
 *
 * Verbindet die Nummern-Hotspots auf der Explosionszeichnung mit der
 * Teileliste und den Detailkarten. Ohne JavaScript bleibt die erste
 * Detailkarte sichtbar und die Teileliste ist vollständig lesbar —
 * die Seite funktioniert also auch dann.
 */
class PartsDiagram extends HTMLElement {
  connectedCallback() {
    this.panels = Array.from(this.querySelectorAll('[data-pd-panel]'));
    this.triggers = Array.from(this.querySelectorAll('[data-pd-target]'));
    if (!this.panels.length) return;

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        this.select(trigger.dataset.pdTarget);
      });
    });

    this.addEventListener('keydown', this.onKeydown);
    this.select(this.dataset.initial || '0');
  }

  disconnectedCallback() {
    this.removeEventListener('keydown', this.onKeydown);
  }

  onKeydown = (event) => {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    const hotspots = this.triggers.filter((t) => t.classList.contains('parts-diagram__hotspot'));
    if (!hotspots.includes(document.activeElement)) return;
    event.preventDefault();
    const step = event.key === 'ArrowRight' ? 1 : -1;
    const next = (hotspots.indexOf(document.activeElement) + step + hotspots.length) % hotspots.length;
    hotspots[next].focus();
    this.select(hotspots[next].dataset.pdTarget);
  };

  select(index) {
    this.current = String(index);

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.pdPanel !== this.current;
    });

    this.triggers.forEach((trigger) => {
      const active = trigger.dataset.pdTarget === this.current;
      if (trigger.classList.contains('parts-diagram__hotspot')) {
        trigger.setAttribute('aria-pressed', active ? 'true' : 'false');
      } else {
        trigger.setAttribute('aria-current', active ? 'true' : 'false');
      }
    });
  }
}

if (!customElements.get('parts-diagram')) {
  customElements.define('parts-diagram', PartsDiagram);
}
